import { IRootState } from '../reducers/rootReducer'

export const getBootstrapPreloader = (state: IRootState): boolean => {
  return state.preloader.bootstrapPreloader
}

export const getProgress = (state: IRootState): number => {
  return state.preloader.progress
}
